import { useQuery } from "react-query";
import { Collection } from "../api";

export function useCountries() {
  const { data } = useQuery('countries', Collection.countries);

  return data;
}